import React from 'react';

const Sucess = ({ sucess }) => {
  if (!sucess) return null;
  return <p style={{ color: 'green', margin: '1rem 0 2rem 0' }}>{sucess}</p>;
};

export default Sucess;
